import axios from 'axios'
import * as qs from 'qs'
import isArray from 'lodash/isArray'
import isPlainObject from 'lodash/isPlainObject'
import { clone } from '../utils/lang'

/*
clone
请求过滤掉 undefined；
请求需要过滤掉以 `$$` 开头的属性，$$开头的属性一般用于保存前端的状态，不需要发给后台
如图书列表，如果正在编辑某一项，ui中为了突出该项正在编辑，需要加个属性 item.$$editing=true，
此时如果要保存该项，可以直接 post('book/edit', item)，则 $$editing 属性并不会发送给后台
 */

export function get (url, data) {
  let params = clone(data, true)
  return axios.get(url, {params})
}

export function post (url, data) {
  data = clone(data, true)
  return axios.post(url, data)
}

export function postForm (url, data) {
  data = clone(data, true, true)
  let params = qs.stringify(data, {indices: false})
  return axios.post(url, params)
}

// data 必须是 key value 形式的对象
// value 是 string/File/Blob 也可以是 Array<string/File/Blob>；其他的会转成 string？
export function postFile (url, data) {
  data = clone(data, true, true)
  let form = toFormData(data)
  return axios.post(url, form)
}

export function toFormData (data) {
  let form = new FormData()
  Object.keys(data).forEach(key => {
    let item = data[key]
    let addItem = item => {
      if (isPlainObject(item)) {
        item.uid || item.id && form.append(key, item.uid || item.id)
      } else {
        form.append(key, item)
      }
    }
    if (isArray(item)) {
      item.forEach(addItem)
    } else {
      addItem(item)
    }
  })
  return form
}



// WEBPACK FOOTER //
// ./src/common/http.js